module.exports = __webpack_public_path__ + "img/tabicon_10.009dd761.png";